

































































































































































































































































import {
  Department,
  Forms,
  ResponseSurveyQuestion,
  SurveyQuestions,
} from "@/api";
import { Component, Ref, Vue } from "vue-property-decorator";
import { requiredString, noSpace } from "@/tool/validation";
import { VForm } from "@/common/vuetify_types";
import { selfData } from "@/common/role_utils";
import ConfirmationModule from "@/components/confirmationModule/ConfirmationModule.vue";
import PublishDialog from "../PublishDialog.vue";
import draggable from "vuedraggable";

@Component({
  components: {
    ConfirmationModule,
    draggable,
    PublishDialog,
  },
})
export default class Question extends Vue {
  @Ref("form") readonly form!: VForm;
  formModel = false;
  departmentID = 0;
  question = "";
  title = "";
  subTitle = "";
  allowComments = false;
  allowFeedback = false;
  loading = true;
  companyId = selfData().companyId;
  required_text = [requiredString, noSpace];
  selectEditingQuestion: ResponseSurveyQuestion | null = null;
  saving = false;
  deleting = false;
  deleteDialog = false;
  confirmPublish = false;
  publishing = false;
  savingDraft = false;
  isEdit = false;

  required_select = (v: string) =>
    (v !== "" && v !== undefined && v != "0") || "Required";

  async created() {
    const formId = this.$route.params.formId;
    this.loading = true;
    if (formId)
      await this.$store.dispatch("survey/fetchQuestions", {
        formId,
        dispatchType: "discharge",
      });
    this.loading = false;
  }

  get departments(): Department[] {
    return this.$store.getters["company/departments"]?.map(
      (item: Department) => {
        return {
          ...item,
          header: undefined,
        };
      },
    );
  }

  clearForm() {
    this.selectEditingQuestion = null;
    this.departmentID = 0;
    this.question = "";
    this.allowComments = false;
    this.allowFeedback = false;
    this.isEdit = false;
    this.title = "";
    this.subTitle = "";
    this.form.reset();
    this.form.resetValidation();
  }

  get questions(): SurveyQuestions {
    return this.$store.getters["survey/dischargeQuestions"];
  }

  set questions(values: SurveyQuestions) {
    const requestBody = values.map((item, index) => {
      return {
        ...item,
        order: index,
      };
    });

    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    this.$store.dispatch("survey/sortQuestion", {
      requestBody,
      formId,
      dispatchType: "discharge",
    });
  }

  async submit() {
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    if (this.form.validate()) {
      this.saving = true;
      const requestBody = {
        departmentID: this.departmentID,
        question: this.question,
        allowComment: this.allowComments,
        allowFeedback: this.allowFeedback,
        title: this.title,
        subTitle: this.subTitle,
      };

      await this.$store.dispatch("survey/addQuestion", {
        requestBody,
        formId,
        dispatchType: "discharge",
      });
      this.saving = false;
      this.clearForm();
    }
  }

  async update() {
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to update question");
      return;
    }
    if (this.form.validate()) {
      this.saving = true;
      const requestBody = {
        id: this.selectEditingQuestion?.id,
        departmentID: this.departmentID,
        question: this.question,
        allowComment: this.allowComments,
        allowFeedback: this.allowFeedback,
        title: this.title,
        subTitle: this.subTitle,
      } as ResponseSurveyQuestion;

      await this.$store.dispatch("survey/updateQuestion", {
        requestBody,
        formId,
        dispatchType: "discharge",
      });
      this.saving = false;
      this.clearForm();
    }
  }

  editQuestion(question: ResponseSurveyQuestion) {
    this.question = question.question;
    this.title = question.title || "";
    this.subTitle = question.subTitle || "";
    this.allowComments = question.allowComment || false;
    this.allowFeedback = question.allowFeedback || false;
    this.departmentID = question.departmentId || 0;
    this.isEdit = true;
    this.selectEditingQuestion = question;
  }

  async removeQuestion(question: ResponseSurveyQuestion) {
    this.selectEditingQuestion = question;
    this.deleteDialog = !this.deleteDialog;
  }

  async confirmRemove() {
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    this.deleting = true;
    await this.$store.dispatch("survey/removeQuestion", {
      requestBody: this.selectEditingQuestion,
      formId,
      dispatchType: "discharge",
    });
    this.clearForm();
    this.deleting = false;
    this.deleteDialog = !this.deleteDialog;
  }

  back() {
    this.$router.back();
  }

  async publish() {
    const formId = Number(this.$route.params.formId);
    const forms = JSON.parse(
      JSON.stringify(this.$store.getters["survey/dischargeForms"] || []),
    ) as Forms;
    const requestBody = forms.filter(form => form.id === formId);
    if (!formId || !forms || requestBody.length == 0) {
      this.$store.dispatch("alert/warning", "failed to publish form");
      return;
    }

    const form = requestBody[0];
    form.status = 3;
    this.publishing = true;
    await this.$store.dispatch("survey/updateForm", {
      requestBody: form,
      dispatchType: "discharge",
    });
    this.publishing = false;
    this.confirmPublish = !this.confirmPublish;
  }

  checkStandardQuestion(): boolean {
    if (this.selectEditingQuestion) {
      return this.selectEditingQuestion.id <= 0;
    }

    return false;
  }
}
